import styled from 'styled-components';
import { color3, colorBlack900, mediaQueryMobileLargeMin } from 'styles';

export const ActionsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;

  @media all and ${mediaQueryMobileLargeMin} {
    gap: 24px;
  }
`;

export const ActionButton = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  border: none;
  background: transparent;
  color: #1f2729;
  cursor: pointer;
  gap: 4px;

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ActionIconWrap = styled.span`
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: 1px solid ${color3};
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fff;
`;

export const ActionLabel = styled.span`
  font-size: 13px;
  line-height: 24px;
  font-weight: 400;
  color: ${colorBlack900};
`;
